<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'manuaisCrud'"
          crudName="Manuais"
          newText="Novo Manual"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="false"
          :enableEdit="false"
          :enableDelete="false"
          :enableView="true"
          :enableActive="false"
          :enableReset="false"
          :enableSenhaPath="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "manuaisTable",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      columns: ["id", "titulo", "descricao", "arquivos", "actions"],
      tableData: ["id", "titulo", "descricao"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "titulo"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          titulo: "Título",
          descricao: "Descrição",
          arquivos: "Arquivos",
          actions: "Ações",
        },

        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {},
        templates: {
          descricao: function (h, row) {
            const texto = row.descricao || "";
            return texto.length > 80 ? texto.substring(0, 80) + "…" : texto;
          },
          arquivos: function (h, row) {
            const qtd = (row.arquivos || []).length;
            return qtd > 0
              ? (<span class="badge badge-primary">{qtd}</span>)
              : (<span class="badge badge-secondary">0</span>);
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["arquivos"];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "manuais/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        titulo: "titulo",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>
